













import { defineComponent, PropType, ref, toRefs } from '@nuxtjs/composition-api'

import useFilterBarItem from '@/composables/use-filter-bar-item'
import CustomSelectItem from '@/interfaces/CustomSelectItem'
import { tdCarFilterPc } from '@/modules/ga4'
import useI18n from '@/composables/use-i18n'

export default defineComponent({
  props: {
    value: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const i18n = useI18n()
    const {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,
    } = useFilterBarItem(toRefs(props).value, emit)

    const clickSave = () => {
      saveAndHide()

      tdCarFilterPc({
        payment: selectedItems.value.map(item => i18n.t(item.namePath!).toString()).join(','),
      })
    }
    const clickClear = () => {
      clear()
    }

    const selectedItems = ref<CustomSelectItem[]>([])
    const onUpdate = (value: CustomSelectItem[]) => {
      selectedItems.value = value
    }

    return {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,

      clickSave,
      clickClear,

      onUpdate,
    }
  },
})
